export default __webpack_public_path__ + "static/tdt_logo-fb832748c5ee7e4565f0f9380b708f95.svg";